<template>
  <div>
   
  <section data-v-cccaae64="" class="pixelsbg bs-shadow" style="padding: 30px 0px 20px;">
     <fort-hero/>
  <div class="container">

    
    <div class="award-panel">
          <!--
        <div class="d-flex align-items-center">
            <h1 class="text-white lh1 mb0">Training Events</h1>
          
              <button type="button" class="panel-btn mlauto" @click="open = !open">
                <span class="material-icons">{{ open ? "expand_less" : "add" }}</span>
                {{ open ? "Hide" : "Award Points" }}
            </button>
            
           
          
        </div>
         -->

        <div v-if="open" style="margin-top: 20px;">
            <!-- Event details -->
            <div class="row">
                <div class="col-12 col-lg-4 field">
                    <label>Event Type</label>
                    <select class="form-control" v-model="selectedTypeId">
                        <option :value="null" disabled>Select an event type</option>
                        <option v-for="t in pointTypes" :key="t.ID" :value="t.ID">
                            {{ t.Type }} ({{ t.Points }} pts)
                        </option>
                    </select>
                    <small v-if="selectedType && selectedType.Notes" class="hint">{{ selectedType.Notes }}</small>
                </div>
                <div class="col-12 col-lg-3 field">
                    <label>Date</label>
                    <input type="date" class="form-control" v-model="eventDate" />
                </div>
                <div class="col-12 col-lg-5 field">
                    <label>Notes</label>
                    <input type="text" class="form-control" v-model="notes" :placeholder="`e.g. Chicago Sales Summit ${currentYear}`" />
                </div>
            </div>

            <!-- Attendee search -->
            <div class="field attendee-wrap">
                <label>Add Attendees</label>
                <div class="input-wrap">
  <input
    type="text"
    class="form-control"
    v-model="userSearch"
    @input="queueSearch"
    placeholder="Type at least 2 letters of a first or last name"
    style="padding-right: 44px;"
  />

  <button
    :class="[showUserClear ? 'clear-btn' : 'clear-hide']"
    @click="clearUserSearch"
    type="button"
    class="d-flex align-items-center pr-3 clear-btn"
  >
    <svg
      class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
    >
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path
        d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
      ></path>
    </svg>
  </button>
</div>

                <ul v-if="userResults.length" class="results">
                    <li v-for="u in userResults" :key="u.UserId" :class="{ added: isSelected(u) }"
                        @click="addUser(u)">
                        <span>{{ u.FirstName }} {{ u.LastName }}</span>
                        <small>{{ u.Company }}</small>
                        <span class="material-icons">{{ isSelected(u) ? "check" : "person_add" }}</span>
                    </li>
                </ul>
                <p v-else-if="searching" class="hint">Searching…</p>
                <p v-else-if="userSearch.trim().length >= 2" class="hint">No users found.</p>
            </div>

            <!-- Selected attendees -->
            <div v-if="attendees.length" class="chips">
                <span v-for="u in attendees" :key="u.UserId" class="chip">
                    {{ u.FirstName }} {{ u.LastName }}
                    <a @click="removeUser(u)" title="Remove">&#215;</a>
                </span>
                <a class="clear-all" @click="attendees = []">Clear all</a>
            </div>

            <!-- Submit -->
            <div class="d-flex align-items-center footer">
                <p class="mb0 summary">
                    <template v-if="selectedType && attendees.length">
    {{ attendees.length }} attendee{{ attendees.length === 1 ? "" : "s" }} at
    <b>{{ selectedType.Points }} point{{ selectedType.Points === 1 ? "" : "s" }}</b> each
</template>
                    <template v-else>Pick an event type and add attendees.</template>
                </p>
                <button type="button" class="panel-btn mlauto" :disabled="!canSubmit" @click="confirmAward">
                    
                    {{ submitting ? "Saving…" : "Submit Credits" }}
                </button>
            </div>
        </div>
        </div>
    </div>
</section>

    <!-- bottom -->
    <div class="container">
    
      <TrainingPagination
    :currPage="currPage"
    :totalPage="totalPage"
    :filteredPosts="filteredUsers"
    :setPage="setPage"
    :countOfPage="countOfPage"
    class="mb10"
    style="margin-top: 20px!important;"
  />

    <div style="background-color: #fff; line-height: 1; padding: 20px;">
<div class="d-flex align-items-center filters" style="margin-bottom: 20px;">
  <h2 class="mb0">Sales Reps</h2>

  <select class="form-control mlauto" style="max-width: 160px;" v-model="selectedYear">
    <option value="all">All years</option>
    <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
  </select>

  <input
    class="form-control"
    style="max-width: 240px;"
    v-model="allUsersFilter"
    placeholder="Filter by name or company"
  />

  <button
    type="button"
    class="csv-btn"
    :disabled="loadingAllUsers || !filteredUsers.length"
    @click="downloadCSV"
  >
    <span class="material-icons">download</span> Download CSV
  </button>
</div>

  

  <div v-if="loadingAllUsers" class="flexVHcenter" style="min-height: 200px;">
    <p>Loading…</p>
  </div>

  <table v-else-if="paginatedUsers.length" class="table-striped table-bordered" style="display: table; width: 100%;">
    <thead>
      <tr>
        
        <th @click="sortCol('LastName')" class="table-link" :class="{ 'column-active': columnSort === 'LastName' }" style="width: 20%;">
          Rep Name
        </th>
        <th @click="sortCol('Company')" class="table-link" :class="{ 'column-active': columnSort === 'Company' }">
          Company
        </th>
         <th @click="sortCol('CreateDate')" class="table-link" :class="{ 'column-active': columnSort === 'CreateDate' }" style="width: 12%;">
         Start Date
        </th>
      
<th @click="sortCol('QuizPoints')" class="table-link" :class="{ 'column-active': columnSort === 'QuizPoints' }" style="width: 14%;">Quiz Credits ({{ yearLabel }}))</th>
<th @click="sortCol('EventPoints')" class="table-link" :class="{ 'column-active': columnSort === 'EventPoints' }" style="width: 14%;">Event Credits ({{ yearLabel }})})</th>
<th @click="sortCol('TotalPoints')" class="table-link" :class="{ 'column-active': columnSort === 'TotalPoints' }" style="width: 14%;">
  Total Credits ({{ yearLabel }}))
</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="u in paginatedUsers" :key="u.UserId">
        
        <td>
    <router-link :to="`/fortified-learning/admin/user/${u.UserId}`" style="color: #00b4b4;">
        {{ u.FirstName + " " + u.LastName }}
    </router-link>
</td>
        <td>{{ u.Company }}</td>
        <td>{{$moment(u.CreateDate).format("MM-DD-YYYY")}}</td>
        <td>{{ u.QuizPoints }}</td>
<td>{{ u.EventPoints }}</td>
<td>{{ u.TotalPoints }}</td>

      </tr>
    </tbody>
  </table>

  <p v-else class="hint" style="margin: 20px 0;">No users to show.</p>

  
</div>
<TrainingPagination
    :currPage="currPage"
    :totalPage="totalPage"
    :filteredPosts="filteredUsers"
    :setPage="setPage"
    :countOfPage="countOfPage"
    class="mt10"
  />
</div>
</div>
</template>

<script>
import { checkTokenOrLogout } from '@/utils/auth';
import axios from "axios";
import TrainingPagination from "@/components/Pagination/TrainingPagination.vue";
import FortHero from "@/components/heroes/FortHero.vue";

const auth = () => ({
    headers: { Authorization: "Bearer " + localStorage.getItem("SSCUSER") },
});

export default {
    name: "FortLearningPoints",
    emits: ["awarded"],
    components: { TrainingPagination, FortHero },
    data() {
        return {
            server: import.meta.env.VITE_APP_SERVER_URL,
            // server: 'http://localhost:5002',
            currentYear: new Date().getFullYear(),
            open: true,
            pointTypes: [],
            selectedTypeId: null,
            eventDate: new Date().toISOString().slice(0, 10),
            notes: "",
            userSearch: "",
            userResults: [],
            searching: false,
            searchTimer: null,
            attendees: [],
            submitting: false,
            allUsers: [],
            loadingAllUsers: false,
            allUsersFilter: "",
            currPage: 1,
            countOfPage: 50,
            columnSort: "",
            colSort: true,
            selectedYear: new Date().getFullYear(),
            usersRequestId: 0,
        };
    },
    computed: {
        yearLabel() {
          return this.selectedYear === "all" ? "All years" : String(this.selectedYear);
        },
        selectedType() {
            return this.pointTypes.find(t => t.ID === this.selectedTypeId) || null;
        },
        canSubmit() {
            return !!this.selectedType && !!this.eventDate && this.notes.length && this.attendees.length > 0 && !this.submitting;
        },
        showUserClear() {
    return this.userSearch.trim().length > 0;
},
        filteredUsers() {
  const term = (this.allUsersFilter || "").trim().toLowerCase();
  let rows = this.allUsers || [];
  if (term) {
    rows = rows.filter(u =>
      `${u.FirstName} ${u.LastName} ${u.Company || ""}`.toLowerCase().includes(term)
    );
  }
  return rows;
},
pageStart() {
  return (this.currPage - 1) * this.countOfPage;
},
totalPage() {
  return Math.ceil(this.filteredUsers.length / this.countOfPage) || 1;
},
paginatedUsers() {
  return this.filteredUsers.slice(this.pageStart, this.pageStart + this.countOfPage);
},
years() {
    const y = new Date().getFullYear();
    return [y + 1, y, y - 1]; // next, current, last
  },
    },
    methods: {
        loadPointTypes() {
            return axios
                .get(`${this.server}/api/v1/training-point-types`, auth())
                .then(res => {
                    const body = res.data;
                    this.pointTypes = Array.isArray(body) ? body : (body?.data || []);
                })
                .catch(this.handleError);
        },
        getAllUsers() {
  this.loadingAllUsers = true;
  const requestId = ++this.usersRequestId; // ignore slower, older responses

  return axios
    .get(`${this.server}/api/v1/all-training-users`, {
      ...auth(),
      params: { year: this.selectedYear },
    })
    .then(res => {
      if (requestId !== this.usersRequestId) return;
      const body = res.data;
      const users = Array.isArray(body) ? body : (body?.data || []);
      this.allUsers = users.sort((a, b) =>
        `${a.LastName} ${a.FirstName}`.localeCompare(`${b.LastName} ${b.FirstName}`)
      );
    })
    .catch(this.handleError)
    .finally(() => {
      if (requestId === this.usersRequestId) this.loadingAllUsers = false;
    });
},

downloadCSV() {
  const rows = this.filteredUsers;
  if (!rows.length) return;

  const cell = value => {
    let s = String(value ?? "");
    if (/^[=+\-@]/.test(s)) s = "'" + s;   // stop Excel running it as a formula
    return `"${s.replace(/"/g, '""')}"`;
  };

  const label = this.yearLabel;
  const header = [
    "First Name", "Last Name", "Company", "Start Date",
    `Quiz Credits (${label})`, `Event Credits (${label})`, `Total Credits (${label})`,
  ];

  const lines = rows.map(u => [
    u.FirstName,
    u.LastName,
    u.Company || "",
    u.CreateDate ? this.$moment(u.CreateDate).format("MM-DD-YYYY") : "",
    u.QuizPoints,
    u.EventPoints,
    u.TotalPoints,
  ].map(cell).join(","));

  const csv = "\uFEFF" + [header.map(cell).join(","), ...lines].join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

  const yearPart = this.selectedYear === "all" ? "all-years" : this.selectedYear;
  const filename = `sales-rep-credits-${yearPart}.csv`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
},
        queueSearch() {
            clearTimeout(this.searchTimer);
            const term = this.userSearch.trim();
            if (term.length < 2) {
                this.userResults = [];
                return;
            }
            this.searchTimer = setTimeout(() => this.searchUsers(term), 300);
        },
        searchUsers(term) {
            this.searching = true;
            return axios
                .get(`${this.server}/api/v1/search-training-users`, { ...auth(), params: { search: term } })
                .then(res => {
                    // ignore stale responses if the user kept typing
                    if (term !== this.userSearch.trim()) return;
                    const body = res.data;
                    this.userResults = Array.isArray(body) ? body : (body?.data || []);
                })
                .catch(this.handleError)
                .finally(() => { this.searching = false; });
        },
        clearUserSearch() {
    clearTimeout(this.searchTimer);
    this.userSearch = "";
    this.userResults = [];
},
        isSelected(u) {
            return this.attendees.some(a => a.UserId === u.UserId);
        },
        setPage(idx) {
  if (idx <= 0 || idx > this.totalPage) return;
  this.currPage = idx;
},
sortCol(type) {
  this.columnSort = type;
  const dir = this.colSort ? 1 : -1;
  this.allUsers.sort((a, b) => {
    const av = a[type] ?? "";
    const bv = b[type] ?? "";
    if (typeof av === "number" && typeof bv === "number") return (av - bv) * dir;
    return String(av).localeCompare(String(bv)) * dir;
  });
  this.colSort = !this.colSort;
},
        addUser(u) {
            if (!this.isSelected(u)) this.attendees.push(u);
        },
        removeUser(u) {
            this.attendees = this.attendees.filter(a => a.UserId !== u.UserId);
        },
        confirmAward() {
    if (!this.canSubmit) return;

    const esc = s => String(s ?? "").replace(/[&<>"']/g, c => (
        { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
    ));

    const pts = this.selectedType.Points;
    const ptsLabel = `${pts} point${pts === 1 ? "" : "s"}`;
    const notes = this.notes.trim();

    const rows = this.attendees.map(u => `
        <li style="display:flex; justify-content:space-between; gap:10px; padding:6px 0; border-bottom:1px solid #eee;">
            <span>${esc(u.FirstName)} ${esc(u.LastName)}</span>
            <small style="color:#777; text-align:right;">${esc(u.Company)}</small>
        </li>`).join("");

    this.$swal({
        title: "Award points?",
        html: `
            <p style="font-weight:300; margin-bottom:10px;">
                ${notes ? `<b style="font-weight:600;">${esc(notes)}</b><br/>` : ""}
                ${esc(this.selectedType.Type)} on ${this.$moment(this.eventDate).format("MM-DD-YYYY")}<br/>
                Each attendee receives <b>${ptsLabel}</b>.
            </p>
            <ul style="list-style:none; padding:0; margin:0; text-align:left; max-height:250px; overflow-y:auto; font-size:15px;">
                ${rows}
            </ul>`,
        showCancelButton: true,
        confirmButtonText: "Award",
    }).then(result => {
        if (result.isConfirmed || result.value) this.submitAward();
    });
},
        submitAward() {
            this.submitting = true;
            const payload = {
                pointTypeId: this.selectedTypeId,
                userIds: this.attendees.map(a => a.UserId),
                eventDate: this.eventDate,
                notes: this.notes.trim() || null,
            };
            return axios
                .post(`${this.server}/api/v1/training-points/award`, payload, auth())
                .then(res => {
                    const { awarded = 0, skipped = 0 } = res.data || {};
                    let msg = `Awarded points to ${awarded} user${awarded === 1 ? "" : "s"}.`;
                    if (skipped) msg += ` ${skipped} already had points for this event.`;
                    this.$toast.success(msg);
                    this.attendees = [];
                    this.userSearch = "";
                    this.userResults = [];
                    this.notes = "";
                    this.$emit("awarded", payload);
                    this.getAllUsers();
                })
                .catch(this.handleError)
                .finally(() => { this.submitting = false; });
        },
        handleError(error) {
            if (error.request?.status === 401) {
                this.$toast.error("Your session has timed out. Please sign in to continue.", { hideProgressBar: false, icon: false });
                this.$router.push("/");
                return;
            }
            this.$toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
        },
    },
    created() {
		if (checkTokenOrLogout()) return;
		this.$store.commit("showNavigation");
	},
    mounted() {
        this.loadPointTypes();
        this.getAllUsers();
    },
    beforeUnmount() {
        clearTimeout(this.searchTimer);
    },
    watch: {
      allUsersFilter() {
        this.currPage = 1;
      },
      selectedYear() {
        this.currPage = 1;
        this.getAllUsers();
      },
    },
};
</script>

<style scoped>
/* Panel sits on the header background */
.award-panel {
    background: transparent;
    padding: 0;
    color: #fff;
    line-height: 1.2;
}

.field {
    margin-bottom: 15px;
}

.field label {
    display: block;
    color: #fff;
    font-weight: 300;
    font-size: 18px;
    margin-bottom: 6px;
}

.hint {
    display: block;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 6px;
    font-size: 0.9em;
}

/* White inputs like the header search */
.award-panel .form-control {
    background: #fff;
    border: none;
    border-radius: 4px;
    height: 50px;
    padding: 0 15px;
    font-size: 16px;
    color: #333;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.award-panel .form-control:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 157, 168, 0.5);
}

/* Dark button like the header's Search button */
.panel-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: #4d5967;
    color: #fff;
    border-radius: 4px;
    padding: 0 18px;
    height: 50px;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.panel-btn:hover {
    background: #586575;
}

.panel-btn:disabled {
    opacity: 0.6;
    cursor: default;
}

.panel-btn .material-icons {
    font-size: 20px;
}

/* Search results: white dropdown so it stays readable */
.search-wrap {
    position: relative;
}

.results {
    list-style: none;
    margin: 4px 0 0;
    padding: 0;
    background: #fff;
    color: #333;
    border-radius: 4px;
    max-height: 260px;
    overflow-y: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.results li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 15px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
}

.results li:last-child {
    border-bottom: none;
}

.results li:hover {
    background: #f5f8f9;
}

.results li small {
    color: #777;
}

.results li .material-icons {
    margin-left: auto;
    font-size: 20px;
    color: #429da8;
}

.results li.added {
    opacity: 0.55;
    cursor: default;
}

/* Selected attendees: translucent pills */
.chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
}

.chip {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 16px;
    padding: 6px 10px 6px 14px;
}

.chip a {
    margin-left: 6px;
    cursor: pointer;
    font-weight: bold;
    color: #fff;
}

.clear-all {
    cursor: pointer;
    color: #fff;
    text-decoration: underline;
    font-size: 0.9em;
}

.footer {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 15px;
    margin-top: 5px;
}

.summary {
    color: #fff;
    font-weight: 300;
    font-size: 16px;
}
.attendee-wrap {
    position: relative;
    background: transparent;
    padding: 0;
    box-shadow: none;
}
.award-panel .field label {
    display: block;
    color: #fff;
    font-weight: 300;
    font-size: 18px;
    margin-bottom: 6px;
    opacity: 1;
}
.input-wrap {
  position: relative;
  display: block;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 13px;
  border: none;
  background: none;
  color: #333;
  cursor: pointer;
}
.clear-hide {
  display: none !important;
}
thead th {
    border-bottom-width: 2px;
    color: #fff;
    padding: 5px;
    font-weight: 300 !important;
}
.filters {
  flex-wrap: wrap;
  gap: 10px;
}
.csv-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 0 14px;
  height: 38px;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
}
.csv-btn:hover {
  background: #586575;
}
.csv-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.csv-btn .material-icons {
  font-size: 18px;
}
</style>
